import { render } from "./studioLog.vue?vue&type=template&id=80b4585c&scoped=true"
import script from "./studioLog.vue?vue&type=script&lang=js"
export * from "./studioLog.vue?vue&type=script&lang=js"

import "./studioLog.vue?vue&type=style&index=0&id=80b4585c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80b4585c"]])

export default __exports__